<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog db-adapter-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-dsm drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-dsm" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          DB Adapter
        </font>
        <v-spacer></v-spacer>
        <v-btn
          class="btn btn-save rounded-xl mr-2"
          :disabled="!$auth.manage || isDisableSave"
          v-if="!isHistory"
          @click="save"
          >{{ $t('btn.common.save') }}</v-btn
        >
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="8" class="pl-3 pr-2 py-0">
          <v-label
            ><v-icon x-small class="mr-1">fa fa-asterisk</v-icon
            >{{ $t('lbl.dataSource.form.name') }}</v-label
          >
          <v-autocomplete
            v-model="comId"
            :items="dbAdapterList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage || this.comTp === 'DBAC'"
            :readonly="isHistory"
            item-value="dba_child_id"
            item-text="dba_name"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="4" class="pr-3 pl-5 py-0" style="padding-top: 35px !important">
          <v-label>
            Type :
          </v-label>
          <span class="dba-value">
            {{ saveData.dba_type_name }}
          </span>
        </v-col>
        <v-col
          v-if="
            saveData.dba_type === 'D2J' ||
              saveData.dba_type === 'D2D' ||
              saveData.dba_type === 'D2F'
          "
          cols="12"
          md="4"
          class="pl-3 pr-2 py-2"
        >
          <v-label>
            Agent
          </v-label>
        </v-col>
        <v-col
          v-if="
            saveData.dba_type === 'D2J' ||
              saveData.dba_type === 'D2D' ||
              saveData.dba_type === 'D2F'
          "
          cols="12"
          md="8"
          class="pl-2 pr-3 py-2"
        >
          <span class="dba-value"> {{ saveData.source_agent_name }} - {{ saveData.address }} </span>
        </v-col>
        <v-col
          v-if="saveData.dba_type === 'J2D' || saveData.dba_type === 'D2D'"
          cols="12"
          md="4"
          class="pl-3 pr-2 py-2"
        >
          <v-label>
            Agent
          </v-label>
        </v-col>
        <v-col
          v-if="saveData.dba_type === 'J2D' || saveData.dba_type === 'D2D'"
          cols="12"
          md="8"
          class="pl-2 pr-3 py-2"
        >
          <span class="dba-value"> {{ saveData.target_agent_name }} - {{ saveData.address }} </span>
        </v-col>
        <v-col cols="12" md="12" class="pl-3 pr-2 py-2">
          <v-label>
            DB Interface Configuration
          </v-label>
        </v-col>
        <v-col cols="12" md="1" class="pl-3 pr-2 py-2"></v-col>
        <v-col cols="12" md="11" class="pl-2 pr-3 py-2">
          <v-row>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                Origin System
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <span class="dba-value">
                {{ saveData.dba_from }}
              </span>
            </v-col>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                Target System
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <span class="dba-value">
                {{ saveData.dba_to }}
              </span>
            </v-col>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                Interface Module
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <span class="dba-value">
                {{ saveData.config_module }}
              </span>
            </v-col>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                DB Instance
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <span class="dba-value">
                {{ saveData.config_db_instance }}
              </span>
            </v-col>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                Interface Control Table
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <span class="dba-value">
                {{ saveData.config_table }}
              </span>
            </v-col>
            <v-col cols="12" md="4" class="pl-2 pr-2 py-2">
              <span class="dba-title">
                Interface Condition
              </span>
            </v-col>
            <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
              <p v-for="(item, index) in listInterface" :key="index" class="dba-value">
                {{ item.col }} : {{ item.val }}
              </p>
            </v-col>
          </v-row>
        </v-col>
        <v-col
          cols="12"
          md="4"
          class="pl-3 pr-2 py-2"
          v-if="saveData.type !== 'D2F' && saveData.type !== 'D2D'"
        >
          <v-label>
            DB Mapper
          </v-label>
        </v-col>
        <v-col
          v-if="saveData.type !== 'D2F' && saveData.type !== 'D2D'"
          cols="12"
          md="8"
          class="pl-2 pr-3 py-2"
        >
          <span class="dba-value">
            {{ saveData.mapper_name }}
          </span>
        </v-col>
        <v-col cols="12" md="12" class="pl-3 pr-3 py-2">
          <a
            v-if="!saveData.dba_child_id"
            class="underline"
            @click="openAddAdapterWindow(saveData, 'Add')"
            :disabled="!$auth.manage || isHistory"
          >
            Add DB Adapter
          </a>
          <a
            v-else
            class="underline"
            @click="openAddAdapterWindow(saveData, 'Edit')"
            :disabled="!$auth.manage || isHistory"
          >
            Edit DB Adapter
          </a>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-2">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.communications.exeInterval') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="4" class="pl-3 pr-2 py-2">
          <v-text-field
            ref="interval"
            v-model="saveData.dba_interval"
            type="number"
            :rules="[validationUtils.required, validateInterval(intervalDefault)]"
            solo
            min="1"
            @mouseup="stopAuto($event)"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="8" class="pr-3 pl-2 py-2">
          <v-select
            v-model="intervalDefault"
            :items="intervals"
            return-object
            solo
            :menu-props="{ offsetY: true }"
            :disabled="!$auth.manage"
            :readonly="isHistory"
          ></v-select>
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['Converter', 'modified'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="errorDialog"
      size="max"
      title="Merge & Compare"
      :detail="add_valid_str"
      color="error"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { mapActions, mapGetters } from 'vuex';
import { openWindow } from '@/vue-dlb/utils/window-opener';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'DBA',
      saveData: {
        dba_name: '',
        dba_from: '',
        dba_to: '',
        config_module: '',
        dba_conf_id: '',
        dba_mapper_id: '',
        dba_sql_id: '',
        dba_type: '',
        dba_interval: '',
        dba_interval_type: '',
      },
      loadFormData: {},
      DB_CONF_NM: '',
      XML_NM: '',
      SQL_GRP_NM: '',
      intervals: [
        { text: this.$t('msg.communications.seconds'), value: 'SS' },
        { text: this.$t('msg.communications.minutes'), value: 'MM' },
        { text: this.$t('msg.communications.hours'), value: 'HH' },
      ],
      intervalDefault: {
        text: this.$t('msg.communications.minutes'),
        value: 'MM',
      },
      dataTypes: [
        { text: 'D2J', value: 'D2J' },
        { text: 'D2D', value: 'D2D' },
        { text: 'D2F', value: 'D2F' },
        { text: 'J2D', value: 'J2D' },
      ],
      listInterface: [],
      isDisableSave: true,
      editedItem: {
        action: '',
      },
      add_valid_str: '',
    };
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  computed: {
    ...mapGetters(['agentAdapterList', 'dbAdapter', 'companyAdapterList']),
    dbAdapterList() {
      let data = [];
      if (this.comTp == 'DBAC') {
        data = this.$store.getters.dataDBASelectBox;
      } else {
        this.$store.getters.dataDBASelectBox.forEach((tmpDba) => {
          if (tmpDba.dba_type !== 'D2D' || tmpDba.dba_id === tmpDba.dba_child_id) {
            data.push(tmpDba);
          }
        });
      }
      return data;
    },
  },
  methods: {
    ...mapActions(['getAgentAdapterList', 'getCompanyList']),
    openAddAdapterWindow(item, type) {
      let isEdit = false;
      let params = {};
      if (type === 'Edit') {
        this.editedItem = Object.assign({}, item);
        this.editedItem.action = 'Edit';
        this.editedItem.formtitle = 'Modify DB Adapter';
        isEdit = true;
        params = {
          ROWID: item.dba_child_id.toString(),
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: item.dba_child_id.toString(),
            isEdit: isEdit,
            company: this.companyAdapterList,
          },
        };
      } else {
        item = { dba_child_id: '0' };
        this.editedItem = {};
        this.editedItem.action = 'Add';
        this.editedItem.formtitle = 'Add DB Adapter';
        params = {
          ROWID: '0',
          editedItem: Object.assign({}, this.editedItem),
          options: {
            id: '0',
            isEdit: isEdit,
            company: this.companyAdapterList,
          },
        };
      }
      item.id = item.dba_child_id;

      const arrView = {
        item,
        type,
      };

      const url = `/component/dbadapter/dbadapterbuilder/${type}/${params.options.id}`;
      openWindow({
        arrView,
        url: url,
        params,
      });
    },
    save() {
      if (!this.saveData.dba_child_id) return;
      if (this.intervalDefault.value) {
        this.saveData.dba_interval_type = this.intervalDefault.value;
      }
      const saveAll = {
        dba_name: this.saveData.dba_name,
        dba_id: this.saveData.dba_child_id,
        dba_type: this.saveData.dba_type,
        dba_conf_id: this.saveData.dba_conf_id,
        dba_mapper_id: this.saveData.dba_mapper_id,
        conf_add: this.saveData.config_address,
        conf_port: this.saveData.config_port,
        sql_grp_id: this.saveData.sql_grp_id,
        dba_interval: this.saveData.dba_interval,
        dba_interval_type: this.saveData.dba_interval_type,
      };
      this.$store
        .dispatch('updateDBAdapter', saveAll)
        .then(() => {
          let formEmit = {
            comId: this.saveData.dba_child_id,
            nodeId: this.nodeId,
            type: this.comTp,
          };
          EventBus.$emit('refresh-list-component', formEmit);
          this.$refs.ModifiedSuccess.dialog = true;
        })
        .catch((e) => {
          this.add_valid_str = 'Update DB Adapter failed.';
          this.$refs.errorDialog.dialog = true;
        });
    },
    findIndexItem(arrView, arr, col) {
      let prop = typeof col == 'undefined' ? 'id' : col;
      let index = arr.findIndex((row) => {
        return row.item[prop] === arrView.item[prop] && row.type === arrView.type;
      });
      return index > -1 ? index : null;
    },
    changeComponentData() {
      this.changeDBAdapter(this.comId);
    },
    stopAuto(e) {
      e.stopPropagation();
    },
    loadXmlMap() {
      EventBus.$emit('loadXmlMap', { ds_xml_id: this.saveData.xml_id });
    },
    loadDBConfig() {
      EventBus.$emit('loadDBConfig', { ds_conf_id: this.saveData.ds_db_conf_id });
    },
    loadSqlGroup() {
      if (this.saveData.dba_type === 'D2D') {
        EventBus.$emit('loadSqlGroupD2D', { ds_sql_id: this.saveData.sql_grp_id });
      } else {
        EventBus.$emit('loadSqlGroup', { ds_sql_id: this.saveData.sql_grp_id });
      }
    },

    validateInterval(item) {
      let interval = this.saveData.dba_interval;
      if (interval) {
        switch (item.value) {
          case 'SS': {
            if (interval < 10 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['10', '59', 'seconds']);
            }
            break;
          }
          case 'HH': {
            if (interval < 1 || interval > 24) {
              return this.$t('msg.communications.validateInterval', ['1', '24', 'hours']);
            }
            break;
          }
          default: {
            if (interval < 1 || interval > 59) {
              return this.$t('msg.communications.validateInterval', ['1', '59', 'minutes']);
            }
          }
        }
      }
      return true;
    },
    initialize() {
      this.getCompanyList();
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.changeDBAdapter(this.options.item.data.comId);
    },
    changeDBAdapter(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      let index = this.dbAdapterList.findIndex((e) => e.dba_child_id == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.saveData = Object.assign({}, this.dbAdapterList[index]);
        this.loadFormData = Object.assign({}, this.dbAdapterList[index]);
        this.comId = Object.assign({}, this.dbAdapterList[index]);
        (this.saveData.dba_from = this.saveData.from_to.split(' - ')[0]),
          (this.saveData.dba_to = this.saveData.from_to.split(' - ')[1]),
          (this.XML_NM = this.saveData.mapper_name);
        this.DB_CONF_NM = this.saveData.config_name;
        this.SQL_GRP_NM = this.saveData.sql_grp_name;
        if (!this.saveData.dba_interval) {
          this.saveData.dba_interval = '30';
        }
        if (this.saveData.dba_interval_type) {
          this.intervalDefault = this.intervals.filter(
            (item) => item.value === this.saveData.dba_interval_type,
          )[0];
        }
        if (this.saveData.dba_type === 'D2J' || this.saveData.dba_type === 'D2F') {
          this.saveData.source_agent_id = this.saveData.agent_id;
          this.loadFormData.source_agent_id = this.saveData.agent_id;
        } else if (this.saveData.dba_type === 'J2D') {
          this.saveData.target_agent_id = this.saveData.agent_id;
          this.loadFormData.target_agent_id = this.saveData.agent_id;
        } else if (this.saveData.dba_type === 'D2D') {
          this.saveData.source_agent_id = this.saveData.agent_id;
          this.loadFormData.source_agent_id = this.saveData.agent_id;
        }

        this.getAgentAdapterList();
        const agentList = this.agentAdapterList;
        let indexSource = agentList.findIndex((e) => e.agentId === this.saveData.source_agent_id);
        if (indexSource > -1) {
          this.saveData.source_agent_name = agentList[indexSource].agentNm;
        }
        let indexTarget = agentList.findIndex((e) => e.agentId === this.saveData.target_agent_id);
        if (indexTarget > -1) {
          this.saveData.target_agent_name = agentList[indexTarget].agentNm;
        }

        this.$store.dispatch('getAdapterId', { id: this.saveData.dba_conf_id }).then(() => {
          this.listInterface = [];
          for (let i = 0; i < this.dbAdapter.selectSQL.length; i++) {
            this.listInterface.push({
              col: this.dbAdapter.selectSQL[i].col || '',
              val: this.dbAdapter.selectSQL[i].val,
            });
          }
          this.saveData.listInterface = this.listInterface;
          this.loadFormData.listInterface = this.listInterface;
        });
        if (this.saveData.dba_type === 'D2J') {
          this.saveData.dba_type_name = ' DB to JSON';
        } else if (this.saveData.dba_type === 'J2D') {
          this.saveData.dba_type_name = ' JSON to DB';
        } else if (this.saveData.dba_type === 'D2D') {
          this.saveData.dba_type_name = ' DB to DB';
        } else if (this.saveData.dba_type === 'D2F') {
          this.saveData.dba_type_name = ' DB to File';
        }
        this.isDisableSave = false;
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        if (!this.saveData.interval) {
          this.saveData.interval = '30';
        }
        if (this.saveData.dba_interval_type) {
          this.intervalDefault = this.intervals.filter(
            (item) => item.value === this.item.intervalType,
          )[0];
        } else {
          this.intervalDefault = {
            text: this.$t('msg.communications.minutes'),
            value: 'MM',
          };
        }
        this.DB_CONF_NM = '';
        this.XML_NM = '';
        this.SQL_GRP_NM = '';
        this.saveData = {
          byProcSetup: true,
          dba_id: '',
          dba_child_id: '',
          dba_name: '',
          from_to: '',
          config_module: '',
          xml_id: '',
          xml_name: '',
          dba_type: '',
          dba_conf_id: '',
          config_name: '',
          sql_grp_id: '',
          sql_grp_name: '',
        };
        EventBus.$emit('change-component-data', '', this.nodeId);
      }
    },
    closeComDialog() {
      this.checkDataChange();
    },

    checkDataChange() {
      if (this.intervalDefault.value) {
        this.saveData.dba_interval_type = this.intervalDefault.value;
      }
      let editedData = getEditData(this.saveData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>

<style></style>
